import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../_models/oauth.models';
import { Role, RoleInitPage, Pages } from '../_models/oauth.models';
import { ZeroService } from './zero/zero.service';
import { REST_SERVICES } from './settings';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/_services/session.service';
import { CookieService } from 'ngx-cookie-service';
import { Globals } from 'src/app/_services/zero/globals';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(
        private http: HttpClient,
        private zeroService: ZeroService,
        private router: Router,
        private session: SessionService,
        private cookieService: CookieService,
        public globals: Globals,) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    /*
     *  Obtine la url de la pantalla inicial segun el rol despues de login
     */
    public get redirectForRol(): string {
        let urlRedirect: string = '';
        switch (this.currentUserSubject.value.role) {
            case Role.Ejecutor:
                urlRedirect = RoleInitPage.Ejecutor;
                break;

            case Role.Supervisor:
                urlRedirect = RoleInitPage.Supervisor;
                break;

            case Role.Prevencion:
                urlRedirect = RoleInitPage.Prevencion;
                break;

            case Role.Auditoria:
                urlRedirect = RoleInitPage.Auditoria;
                break;

            case Role.Administrador:
                urlRedirect= RoleInitPage.Administrador;
                break;
        }

        return urlRedirect;
    }

    login(username: string, rol: string, esquema_dsc: string, esquema_id: string) {
        return this.http.post<any>(`/users/authenticate`, { username, rol, esquema_dsc, esquema_id})
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                }
                return user;
            }));
    }

    logout() {
        this.currentUserSubject.next(null);
        var scope = this;
       
        console.log("Se borro redis.");
        console.log("Se borrara session storage.");
        scope.session.deleteFromSession("perfiles");
        console.log("Se borrara cookie.");
        scope.cookieService.delete(environment.app);
        scope.cookieService.deleteAll();
        console.log("Se borrara local storage.");
        localStorage.removeItem('currentUser');
        localStorage.removeItem('currentRol');
        console.log("Se dara logout en Forgerock.");
        scope.globals = new Globals();         
        window.location.href = environment.uris.comunes.logout;
    }
    
    changeScheme() {
        localStorage.removeItem('currentUser');        
        localStorage.removeItem('currentRol');
        this.currentUserSubject.next(null);
    }
}
